// extracted by mini-css-extract-plugin
export default {"curtain":"Curtain_curtain__QnGag","bg":"Curtain_bg__8OQho","inner":"Curtain_inner__wTeAP","curtainImage":"Curtain_curtainImage__ymZ7H","curtainText":"Curtain_curtainText__hU6SB"};